import { useMutation } from '@apollo/client';
import { notification } from 'antd';
import DefaultModal from 'components/common/DefaultModal';
import { FormType } from 'constants/formTypes';
import React from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { useIntl } from 'react-intl';
import IntlMessages, { formatMessage } from 'utils/IntlMessages';

import RecordForm from './RecordForm';
import { IRecordModalType } from './types';

const RecordModal: React.FC<IRecordModalType> = ({
  formType,
  record,
  closeModal,
  userId,
  formTitle,
  updateMutation,
  createMutation,
  formFields,
  detailsFields,
  deleteMutation,
  documentType,
  refetchUserData,
  validationSchema,
}) => {
  const intl = useIntl();
  const [deleteRecordFunction] = useMutation(deleteMutation);

  const deleteRecord = async () => {
    // todo: mutation delete record
    closeModal();
    try {
      if (deleteMutation) {
        await deleteRecordFunction({
          variables: {
            id: record.id,
          },
        });
      }
      notification.success({
        message: 'Delete successfully!',
        duration: 2,
      });
      refetchUserData?.();
    } catch (err) {
      console.error(err);
      notification.error({
        message: 'Delete failed! Please try again.',
        duration: 2,
      });
    }
  };

  return (
    <>
      {(formType === FormType.DELETE || !formType) && (
        <SweetAlert
          show={formType === FormType.DELETE}
          warning
          title={formatMessage(intl, 'appModule.deleteRecordTitle')}
          confirmBtnText={formatMessage(intl, 'appModule.delete')}
          onConfirm={deleteRecord}
          onCancel={closeModal}
          showCancel
          reverseButtons>
          <IntlMessages id='appModule.deleteRecordBody' />
        </SweetAlert>
      )}
      {(formType === FormType.EDIT || formType === FormType.ADD || !formType) && (
        <DefaultModal
          props={{
            title: formType && formType !== FormType.DELETE ? formTitle : '',
            visible: formType !== undefined,
            destroyOnClose: true,
            onCancel: closeModal,
            maskClosable: false,
            cancelButtonProps: { className: 'dark-theme-white-text' },
          }}>
          <RecordForm
            userId={userId}
            validationSchema={validationSchema}
            record={formType === FormType.ADD ? undefined : record}
            closeModal={closeModal}
            mutations={{
              update: updateMutation,
              create: createMutation,
            }}
            fields={{
              form: formFields,
              details: detailsFields,
            }}
            documentType={documentType}
            refetchUserData={refetchUserData}
          />
        </DefaultModal>
      )}
    </>
  );
};

export default React.memo(RecordModal);
